var map = {
	"./c.png": 909,
	"./cpp.png": 933,
	"./css.png": 323,
	"./html.png": 3,
	"./java.png": 604,
	"./js.png": 805,
	"./python.png": 54,
	"./r.png": 404,
	"./react.svg": 993,
	"./swift.png": 635,
	"./ts.png": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335;